(function() {
  const CONFIG = {
    queryParam: 'pv2',
    storageKey: 'um_google_automatic_discount',
    lineItemProperty: '_google_target_price',
    validityMinutes: 30
  };

  // Renderers consume discount data before writing their own price markup.
  // This module never writes prices or schedules visual repairs.
  function now() {
    return Date.now();
  }

  function isLocalDevHost() {
    const host = window.location && window.location.hostname ? window.location.hostname : '';
    return host === '127.0.0.1' || host === 'localhost' || host === '0.0.0.0';
  }

  function decodeTokenPayload(token) {
    if (!token || token.split('.').length < 2) return null;
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64 + '='.repeat((4 - (base64.length % 4 || 4)) % 4);
      const binary = window.atob(padded);
      const utf8 = decodeURIComponent(Array.prototype.map.call(binary, function(ch) {
        return '%' + ('00' + ch.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(utf8);
    } catch (_) {
      return null;
    }
  }

  function getPvTokenFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      return params.get(CONFIG.queryParam);
    } catch (_) {
      return null;
    }
  }

  function getVariantIdFromPayload(payload) {
    if (!payload) return null;
    const offerKey = payload.o;
    if (typeof offerKey !== 'string' || offerKey.indexOf('_') === -1) return null;
    const parts = offerKey.split('_');
    const last = parts[parts.length - 1];
    if (!last) return null;
    return /^\d+$/.test(last) ? String(last) : null;
  }

  function readStoredDiscount() {
    try {
      const raw = localStorage.getItem(CONFIG.storageKey);
      if (!raw) return null;
      const data = JSON.parse(raw);
      const isExpired = data && data.expiry ? now() > data.expiry : true;
      if (!data || !data.price || (!isLocalDevHost() && isExpired)) {
        localStorage.removeItem(CONFIG.storageKey);
        return null;
      }
      return data;
    } catch (_) {
      return null;
    }
  }

  function persistIncomingDiscount() {
    const token = getPvTokenFromUrl();
    if (!token) return null;
    const payload = decodeTokenPayload(token);
    if (!payload || payload.p == null) return null;

    const payloadVariantId = getVariantIdFromPayload(payload);
    const arrivalVariantId = getVariantIdFromUrl() || payloadVariantId || getSelectedVariantId(document);
    const arrivalVariant = findVariantById(arrivalVariantId, document);
    const originalFromPayload = computeOriginalCentsFromPayload(payload.p, payload.dp);
    const discount = {
      price: String(payload.p),
      discountPercent: typeof payload.dp === 'number' ? payload.dp : null,
      currency: payload.c || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP',
      expiry: now() + (CONFIG.validityMinutes * 60 * 1000),
      variantId: arrivalVariantId,
      originalPriceCents: originalFromPayload != null
        ? originalFromPayload
        : (arrivalVariant && typeof arrivalVariant.price === 'number' ? arrivalVariant.price : null)
    };

    try {
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(discount));
    } catch (_) {}

    return discount;
  }

  function normalizeDiscountPercent(dp) {
    const value = Number(dp);
    if (!Number.isFinite(value) || value <= 0) return null;
    return value > 0 && value < 1 ? value * 100 : value;
  }

  function computeOriginalCentsFromPayload(priceMajor, dpRaw) {
    const discountedCents = Math.round(Number(priceMajor) * 100);
    const percent = normalizeDiscountPercent(dpRaw);
    if (!Number.isFinite(discountedCents) || discountedCents <= 0) return null;
    if (!Number.isFinite(percent) || percent <= 0 || percent >= 100) return null;
    const originalCents = Math.round(discountedCents / (1 - (percent / 100)));
    return Number.isFinite(originalCents) && originalCents > discountedCents ? originalCents : null;
  }

  function getGoogleCanonicalOriginalCents() {
    try {
      const data = window.automatedDiscountsLiquidData;
      if (!data || data.currentPrice == null) return null;
      const numeric = Number(data.currentPrice);
      if (!Number.isFinite(numeric) || numeric <= 0) return null;
      return Math.round(numeric * 100);
    } catch (_) {
      return null;
    }
  }

  function findVariantById(variantId, scope) {
    if (!variantId) return null;
    const root = scope || document;
    const variantScripts = root.querySelectorAll('script[data-pdp-pricing-variants]');
    for (let i = 0; i < variantScripts.length; i += 1) {
      try {
        const variants = JSON.parse(variantScripts[i].textContent || '[]');
        if (!Array.isArray(variants)) continue;
        const match = variants.find(function(v) { return String(v && v.id) === String(variantId); });
        if (match) return match;
      } catch (_) {}
    }
    return null;
  }

  function getSelectedVariantId(scope) {
    const root = scope || document;
    const variantIdInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantIdInput && variantIdInput.value) return String(variantIdInput.value);
    return null;
  }

  function getVariantIdFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search || '');
      const id = params.get('variant');
      return id ? String(id) : null;
    } catch (_) {
      return null;
    }
  }

  function getActiveVariantId(scope) {
    return getSelectedVariantId(scope) || getVariantIdFromUrl();
  }

  function isDiscountVariantActive(discount) {
    if (!discount || !discount.variantId) return true;
    const selectedVariantId = getActiveVariantId(document);
    return !!selectedVariantId && String(selectedVariantId) === String(discount.variantId);
  }

  function installFetchInterceptor() {
    if (window.__umGmcFetchPatched) return;
    window.__umGmcFetchPatched = true;

    const originalFetch = window.fetch;
    if (typeof originalFetch !== 'function') return;

    window.fetch = function(resource, init) {
      const discount = readStoredDiscount();
      if (!discount || !discount.price || !isDiscountVariantActive(discount)) {
        return originalFetch.apply(this, arguments);
      }

      const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        return originalFetch.apply(this, arguments);
      }

      try {
        const nextInit = Object.assign({}, init || {});
        const body = nextInit.body;
        const propertyName = 'properties[' + CONFIG.lineItemProperty + ']';
        const propertyValue = String(discount.price);

        if (body instanceof FormData) {
          body.set(propertyName, propertyValue);
        } else if (body instanceof URLSearchParams) {
          body.set(propertyName, propertyValue);
        } else if (typeof body === 'string') {
          const trimmed = body.trim();
          if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
            try {
              const json = JSON.parse(body);
              if (Array.isArray(json.items)) {
                json.items.forEach(function(item) {
                  item.properties = item.properties || {};
                  item.properties[CONFIG.lineItemProperty] = propertyValue;
                });
              } else {
                json.properties = json.properties || {};
                json.properties[CONFIG.lineItemProperty] = propertyValue;
              }
              nextInit.body = JSON.stringify(json);
            } catch (_) {}
          } else {
            const params = new URLSearchParams(body);
            params.set(propertyName, propertyValue);
            nextInit.body = params.toString();
          }
        }

        return originalFetch.call(this, resource, nextInit);
      } catch (_) {
        return originalFetch.apply(this, arguments);
      }
    };
  }

  function resolveVariantPrice(variant, price, comparePrice) {
    const fallback = {
      price: price == null ? variant && variant.price : price,
      comparePrice: comparePrice == null ? (variant && variant.compare_at_price) || 0 : comparePrice,
      googleDiscountActive: false
    };
    const discount = readStoredDiscount();
    if (!variant || !discount || String(discount.variantId) !== String(variant.id)) return fallback;
    const activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (activeCurrency && discount.currency && activeCurrency !== discount.currency) return fallback;

    const discountedCents = Math.round(Number(discount.price) * 100);
    if (!Number.isFinite(discountedCents) || discountedCents <= 0) return fallback;
    const originals = [
      variant.price,
      computeOriginalCentsFromPayload(discount.price, discount.discountPercent),
      discount.originalPriceCents,
      getGoogleCanonicalOriginalCents()
    ].filter(function(value) { return Number.isFinite(value) && value > discountedCents; });
    if (!originals.length) return fallback;
    return {
      price: discountedCents,
      comparePrice: Math.max.apply(null, originals),
      googleDiscountActive: true
    };
  }

  const limitedEditionRows = new Map();
  const limitedEditionControls = new Map();
  const offerBadgeDefaults = new WeakMap();

  function syncOfferBadge(container, quote) {
    const badge = container && typeof container.querySelector === 'function' && container.querySelector('[data-pdp-pseudo-sale-savings]');
    if (!badge) return;
    const label = badge.querySelector('[data-pdp-sale-badge-label]');
    if (!label) return;
    const amount = badge.querySelector('[data-pdp-pseudo-sale-savings-amount]');
    const separator = badge.querySelector('[data-pdp-pseudo-sale-savings-separator]');
    const active = !!(quote && quote.googleDiscountActive);
    if (active && !offerBadgeDefaults.has(badge)) {
      offerBadgeDefaults.set(badge, {label: label.textContent, amountHidden: amount && amount.hidden, separatorHidden: separator && separator.hidden});
    }
    const original = offerBadgeDefaults.get(badge);
    if (!original) return;
    const text = active
      ? ((window.theme && window.theme.strings && window.theme.strings.exclusiveOfferLabel) || 'Exclusive offer')
      : original.label;
    if (label.textContent !== text) label.textContent = text;
    if (amount) amount.hidden = active || original.amountHidden;
    if (separator) separator.hidden = active || original.separatorHidden;
    if (active) badge.classList.remove('hide');
  }

  function syncLimitedEditionAvailability(variant) {
    const blocked = resolveVariantPrice(variant).googleDiscountActive;
    if (!blocked) {
      limitedEditionRows.forEach(function(previous, row) {
        row.removeAttribute('data-google-discount-suppressed');
        row.hidden = previous.hidden;
      });
      limitedEditionControls.forEach(function(wasDisabled, control) {
        if (!wasDisabled && !control.hasAttribute('name-disabled') &&
            !control.closest('.hide-oos-disable, .hide-oos-disabled')) control.disabled = false;
      });
      limitedEditionRows.clear();
      limitedEditionControls.clear();
      return false;
    }

    const rows = document.querySelectorAll('.option_limited_edition, #LimitedEditionHelperText, [class*="io-dep-limited-edition"]');
    // Snapshot controls before change handlers update their dependent fields.
    rows.forEach(function(row) {
      row.querySelectorAll('input, select, textarea, button, fieldset').forEach(function(control) {
        if (!limitedEditionControls.has(control)) limitedEditionControls.set(control, control.disabled);
      });
    });
    rows.forEach(function(row) {
      if (!limitedEditionRows.has(row)) limitedEditionRows.set(row, {hidden: row.hidden});
      if (!row.hasAttribute('data-google-discount-suppressed')) row.setAttribute('data-google-discount-suppressed', '');
      if (!row.hidden) row.hidden = true;
    });
    limitedEditionControls.forEach(function(wasDisabled, control) {
      if ((control.type === 'checkbox' || control.type === 'radio') && control.checked) {
        control.checked = false;
        control.dispatchEvent(new Event('input', {bubbles: true}));
        control.dispatchEvent(new Event('change', {bubbles: true}));
      }
      if (!control.disabled) control.disabled = true;
    });
    return true;
  }

  persistIncomingDiscount();
  window.UMGoogleDiscount = {
    resolveVariantPrice: resolveVariantPrice,
    syncOfferBadge: syncOfferBadge,
    syncLimitedEditionAvailability: syncLimitedEditionAvailability
  };
  installFetchInterceptor();
})();
